import {
  makeFetchSlice,
  fetchHomeDataThunk,
  fetchDataThunk,
} from 'app/redux-fetch'
import { AppDispatch } from 'app/store'
import {
  fetchHomeSubscriptionPrice,
  fetchSubscriptionPrice,
  fetchHomePeriodEnd,
} from 'features/home/api'
import {
  SUBSCRIPTION_HOME_PRICE,
  SUBSCRIPTION_PRICES,
  SUBSCRIPTION_PERIOD_END,
} from 'features/home/consts'

const subscriptionHomePriceSlice = makeFetchSlice(SUBSCRIPTION_HOME_PRICE)

export const subscriptionHomePriceReducer = subscriptionHomePriceSlice.reducer
export const subscriptionHomePriceActions = subscriptionHomePriceSlice.actions

export const fetchHomeSubscriptionPriceThunk = (homeId: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchHomeDataThunk({
        dispatch,
        actions: subscriptionHomePriceActions,
        asyncFunc: () => fetchHomeSubscriptionPrice(homeId),
      })
    } catch (error) {
      console.log(
        'Error getting subscription home price - fetchHomeSubscriptionPriceThunk',
        error
      )
    }
  }
}

const subscriptionPricesSlice = makeFetchSlice(SUBSCRIPTION_PRICES)

export const subscriptionPricesSliceReducer = subscriptionPricesSlice.reducer
export const subscriptionPricesSliceActions = subscriptionPricesSlice.actions

export const fetchSubscriptionPricesSliceThunk = (homeId: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchHomeDataThunk({
        dispatch,
        actions: subscriptionPricesSliceActions,
        asyncFunc: () => fetchSubscriptionPrice(homeId),
      })
    } catch (error) {
      console.log(
        'Error getting subscription home price - fetchSubscriptionPricesSliceThunk2',
        error
      )
    }
  }
}

const subscriptionPeriodEndSlice = makeFetchSlice(SUBSCRIPTION_PERIOD_END)

export const subscriptionPeriodEndSliceReducer =
  subscriptionPeriodEndSlice.reducer
export const subscriptionPeriodEndSliceActions =
  subscriptionPeriodEndSlice.actions

export const fetchSubscriptionPeriodEndSliceSliceThunk = (homeId: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchDataThunk({
        dispatch,
        actions: subscriptionPeriodEndSliceActions,
        asyncFunc: () => fetchHomePeriodEnd(homeId),
      })
    } catch (error) {
      console.log('Error getting period end', error)
    }
  }
}
